export default (state, { payload: { shareId } }) => ({
  ...state,
  boards: { ...state.boards, shareId }
});
